import { render, staticRenderFns } from "./AccountDisableRequestList.vue?vue&type=template&id=da892f40&scoped=true&"
import script from "./AccountDisableRequestList.vue?vue&type=script&lang=js&"
export * from "./AccountDisableRequestList.vue?vue&type=script&lang=js&"
import style0 from "./AccountDisableRequestList.vue?vue&type=style&index=0&id=da892f40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da892f40",
  null
  
)

export default component.exports